// Sugalarm — success card shown briefly after CGM connect.

import { Button } from "../../components/ui/Button";
import type { Provider } from "./providers";

interface Props {
  provider: Provider;
  onContinue: () => void;
  /** Cycle 20: number of historical readings pulled on initial backfill. */
  backfillCount?: number;
}

export function Connected({ provider, onContinue, backfillCount = 0 }: Props) {
  return (
    <div
      style={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 14,
        padding: "32px 20px",
      }}
    >
      <div
        style={{
          width: 76,
          height: 76,
          borderRadius: 999,
          background: "var(--zone-ok-soft)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--zone-ok)",
        }}
      >
        <svg width="38" height="38" viewBox="0 0 38 38" fill="none">
          <path
            d="M9 19 L16 26 L29 13"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <div style={{ fontSize: 22, fontWeight: 600, letterSpacing: "-0.02em" }}>
        {provider.name} connected
      </div>
      <div
        style={{
          fontSize: 13,
          color: "var(--ink-2)",
          textAlign: "center",
          maxWidth: 380,
        }}
      >
        First reading will arrive within a minute.
      </div>
      {backfillCount > 0 ? (
        <div
          style={{
            fontSize: "var(--type-floor)",
            color: "var(--ink-3)",
            textAlign: "center",
            maxWidth: 380,
          }}
        >
          Pulled {backfillCount} reading{backfillCount === 1 ? "" : "s"} from
          the last 24 hours.
        </div>
      ) : null}
      <Button onClick={onContinue} style={{ marginTop: 6 }}>
        Open Sugar Alarm →
      </Button>
    </div>
  );
}
